import { InputSelect } from '@vrplatform/components';
import type { SelectItem } from '@vrplatform/components';
import type { party_enum } from '@vrplatform/graphql';
import { useMemo } from 'react';

const PARTY_OPTIONS: SelectItem<party_enum>[] = [
  {
    label: 'Owner',
    value: 'owners',
  },
  {
    label: 'Manager',
    value: 'manager',
  },
];

type Props = {
  value: party_enum | null;
  setValue: (value: SelectItem<party_enum> | null) => void;
  disabled?: boolean;
  error?: boolean;
  name?: string;
  placeholder?: string;
};

export const InputParty = ({
  setValue,
  value: initial,
  error,
  disabled,
  name,
  placeholder = 'Select party',
}: Props) => {
  const value = useMemo(() => {
    return PARTY_OPTIONS.find((o) => o.value === initial) || null;
  }, [initial]);

  return (
    <InputSelect
      type="single"
      name={name}
      value={value}
      setValue={setValue}
      data={{
        options: PARTY_OPTIONS,
      }}
      inputProps={{
        placeholder,
        error: !!error,
        disabled,
      }}
      dropdownProps={{
        width: 160,
        hideSearch: true,
      }}
    />
  );
};
